/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class FormControlDefinition
 * @version 0.0.1
 * @since April 2018
 * @description attribute editor form control definition
 */
export class FormControlDefinition {
  field_id?: number;
  field_label?: string;
  field_name?: string;
  field_component?: string;
  field_required?: boolean;
  field_editable?: boolean;
  field_type?: string;
  max_length?: number;
  min_length?: number;
  field_multi?: boolean;
  field_search?: string;
  field_float?: number;
  field_group_id?: string;
  opts?: SelectboxOption[];
}

export class SelectboxOption {
  /** The label to display. */
  label: string;
  /** The value to identify. */
  value: number;
}
